<template>
  <Select
    v-bind="$attrs"
    :disabled="disabled"
    v-if="type==='Select'"
    v-model="valueModel"
    @on-change="onChange"
    :placeholder="placeholder"
    clearable
  >
    <Option v-for="item in data" :value="item.id" :key="item.id">{{ item.name }}</Option>
  </Select>
  <CheckboxGroup
    v-bind="$attrs"
    :disabled="disabled"
    v-else-if="type === 'Checkbox'"
    v-model="arryModel"
    @on-change="onChange"
  >
    <Checkbox
      :disabled="disabled"
      v-for="item in data"
      :label="item.id"
      :key="item.id"
    >{{ item.name }}</Checkbox>
  </CheckboxGroup>
  <RadioGroup
    v-bind="$attrs"
    :disabled="disabled"
    v-else-if="type === 'Radio'"
    v-model="valueModel"
    @on-change="onChange"
  >
    <Radio v-for="item in data" :label="item.id" :key="item.id">{{ item.name }}</Radio>
  </RadioGroup>
</template>

<script>
export default {
  model: {
    prop: "value",
    event: "returnValue"
  },
  props: {
    value: {
      type: [String, Number, Array]
    },
    //编码类型
    coding: {
      type: String
    },
    //展示组件
    type: {
      type: String,
      default: "Select"
    },
    disabled: {
      type: Boolean,
      default: false
    },
    name: {
      type: String,
      default: ""
    },
    init: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      data: [],
      disabledGroup: "",
      valueModel: "",
      placeholder: "数据加载中...",
      arryModel: [],
      selectItem: {},
      allItemName: [],
      veryfirst: 0
    };
  },
  watch: {
    coding: function(val) {
      this.loadData();
    },
    value: function(val) {
      if (!val) {
        this.arryModel = [];
        this.valueModel = "";
        this.initData();
      } else {
        if (typeof val === "object") {
          this.arryModel = val;
        } else {
          this.valueModel = val;
          if (typeof val == "string") {
            let nowItems = val.split(",");
            this.arryModel = [];
            for (let v in nowItems) {
              this.arryModel.push(parseInt(nowItems[v]));
            }
          }
        }
      }
    }
  },
  methods: {
    initData() {
      let defaultData = this.data.filter(item => item.domain == "true");
      if (
        !this.value &&
        defaultData.length > 0 &&
        this.init &&
        this.veryfirst < 2
      ) {
        this.valueModel = defaultData[0].id;
        this.arryModel.push(defaultData[0].id);
        this.selectItem = defaultData[0];
        this.$emit("returnValue", defaultData[0].id);
        this.$emit("update:name", defaultData[0].name);
      }
      this.veryfirst++;
    },
    async loadData() {
      let url = this.urlobj.GetCodeByType;
      let res = await this.$get(url, { typeName: this.coding });

      // console.log(res)
      this.data = res.rows;
      this.placeholder = "请选择";
      this.initData();
    },
    onChange(item) {
      if (item) {
        this.allItemName = [];
        this.selectItem = this.data.filter(val => val.id == item)[0];

        if (this.type == "Checkbox") {
          this.$emit("returnValue", item.join(","));
          for (let i = 0; i < item.length; i++) {
            let itemSelect = this.data.filter(val => val.id == item[i])[0];
            if (itemSelect) {
              this.allItemName.push(itemSelect.name);
            }
          }
          this.$emit("update:name", this.allItemName.join(","));
        } else {
          this.$emit("returnValue", item);
          this.$emit("update:name", this.selectItem.name);
        }
      } else {
        this.$emit("returnValue", "");
        this.$emit("update:name", "");
      }
    }
  },
  mounted() {
    if (typeof this.value == "string") {
      if (this.value.indexOf(",") > -1) {
        this.arryModel = [];
        for (let val in this.value.split(",")) {
          this.arryModel.push(parseInt(this.value[val]));
        }
      }
    }
    this.initData();
  },
  created() {
    if (Array.isArray(this.value)) {
      for (let val in this.value) {
        this.arryModel.push(parseInt(this.value[val]));
      }
    } else {
      if (typeof this.value == "string") {
        if (this.value.indexOf(",") > -1) {
          for (let val in this.value.split(",")) {
            this.arryModel.push(parseInt(this.value[val]));
          }
        } else {
          this.arryModel.push(parseInt(this.value));
          this.valueModel = parseInt(this.value);
        }
      } else {
        this.arryModel.push(parseInt(this.value));
        this.valueModel = parseInt(this.value);
      }
    }
    this.loadData();
  }
};
</script>

<style lang="less" scoped>
</style>
